import { render, staticRenderFns } from "./InfoPage.vue?vue&type=template&id=fdc83316&scoped=true"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"
import style0 from "./InfoPage.vue?vue&type=style&index=0&id=fdc83316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc83316",
  null
  
)

export default component.exports